import styled from 'styled-components';

export const TableContainer = styled.div`
    width: 100%;
    overflow-x: auto;
`;

export const Table = styled.table`
    width: 100%;
    font-weight: 600;
    font-size: 15px;
    line-height: 143%;
    letter-spacing: 1.45%;
    text-align: center;
    table-layout: fixed;
`;

export const Th = styled.th`
    font-weight: 800;
    font-size: 15px;
    line-height: 143%;
    letter-spacing: 1.45%;
    border-top: 1px solid #000000;
    border-bottom: 1px solid #000000;
    padding: 10px 0px;
    height: auto;
    width: 150px;
`;

export const Td = styled.td`
    width: 100%;
    border-bottom: 1px solid #000000;
    padding: 12px 0px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`;
